/**
 * All actions for the app, roughly divided by Dux
 */

// User-related actions
export const LOG_IN_REQUESTED = 'LOG_IN_REQUESTED';
export const LOG_OUT_REQUESTED = 'LOG_OUT_REQUESTED';
export const SET_SESSION_SUCCESS = 'SET_SESSION_SUCCESS';
export const SET_SESSION_FAILURE = 'SET_SESSION_FAILURE';
export const CREATE_EMAIL_VERIFICATION_REQUESTED = 'CREATE_EMAIL_VERIFICATION_REQUESTED';
export const CREATE_EMAIL_VERIFICATION_SUCCESS = 'CREATE_EMAIL_VERIFICATION_SUCCESS';
export const CREATE_EMAIL_VERIFICATION_FAILURE = 'CREATE_EMAIL_VERIFICATION_FAILURE';
export const GET_FEATURE_FLAGS_SUCCESS = 'GET_FEATURE_FLAGS_SUCCESS';
export const UPDATE_FEATURE_FLAGS_SUCCESS = 'UPDATE_FEATURE_FLAGS_SUCCESS';
export const GET_FEATURE_FLAGS_REQUESTED = 'GET_FEATURE_FLAGS_REQUESTED';
export const IMPERSONATE_ORG = 'IMPERSONATE_ORG';
export const STOP_ORG_IMPERSONATION = 'STOP_ORG_IMPERSONATION';
export const START_MFA_SIGNUP_FLOW_REQUESTED = 'START_MFA_SIGNUP_FLOW_REQUESTED';
export const START_MFA_SIGNUP_FLOW_SUCCESS = 'START_MFA_SIGNUP_FLOW_SUCCESS';
export const START_MFA_SIGNUP_FLOW_FAILURE = 'START_MFA_SIGNUP_FLOW_FAILURE';
export const GET_MFA_STATUS_REQUESTED = 'GET_MFA_STATUS_REQUESTED';
export const GET_MFA_STATUS_SUCCESS = 'GET_MFA_STATUS_SUCCESS';
export const GET_MFA_STATUS_FAILURE = 'GET_MFA_STATUS_FAILURE';
export const REMOVE_MFA_ENROLLMENT_REQUESTED = 'REMOVE_MFA_ENROLLMENT_REQUESTED';
export const REMOVE_MFA_ENROLLMENT_SUCCESS = 'REMOVE_MFA_ENROLLMENT_SUCCESS';
export const REMOVE_MFA_ENROLLMENT_FAILURE = 'REMOVE_MFA_ENROLLMENT_FAILURE';
export const AWS_SIGNUP_FAILURE = 'AWS_SIGNUP_FAILURE';

// Organization-related actions
export const CREATE_ORG_REQUESTED = 'CREATE_ORG_REQUESTED';
export const CREATE_ORG_SUCCESS = 'CREATE_ORG_SUCCESS';
export const CREATE_ORG_FAILURE = 'CREATE_ORG_FAILURE';
export const UPDATE_ORG_REQUESTED = 'UPDATE_ORG_REQUESTED';
export const UPDATE_ORG_SUCCESS = 'UPDATE_ORG_SUCCESS';
export const UPDATE_ORG_FAILURE = 'UPDATE_ORG_FAILURE';
export const GET_ORG_REQUESTED = 'GET_ORG_REQUESTED';
export const GET_ORG_SUCCESS = 'GET_ORG_SUCCESS';
export const GET_ORG_FAILURE = 'GET_ORG_FAILURE';
export const SEARCH_ORGS_REQUESTED = 'SEARCH_ORGS_REQUESTED';
export const SEARCH_ORGS_SUCCESS = 'SEARCH_ORGS_SUCCESS';
export const SEARCH_ORGS_FAILURE = 'SEARCH_ORGS_FAILURE';
export const SORT_ORGS = 'SORT_ORGS';
export const CREATE_AWS_ORG_REQUESTED = 'CREATE_AWS_ORG_REQUESTED';
export const CREATE_AWS_ORG_SUCCESS = 'CREATE_AWS_ORG_SUCCESS';
export const CREATE_AWS_ORG_FAILURE = 'CREATE_AWS_ORG_FAILURE';

export const CREATE_STRIPE_SOURCE_REQUESTED = 'CREATE_STRIPE_SOURCE_REQUESTED';
export const CREATE_STRIPE_SOURCE_SUCCESS = 'CREATE_STRIPE_SOURCE_SUCCESS';
export const CREATE_STRIPE_SOURCE_FAILURE = 'CREATE_STRIPE_SOURCE_FAILURE';
export const UPDATE_STRIPE_SOURCE_REQUESTED = 'UPDATE_STRIPE_SOURCE_REQUESTED';
export const UPDATE_STRIPE_SOURCE_SUCCESS = 'UPDATE_STRIPE_SOURCE_SUCCESS';
export const UPDATE_STRIPE_SOURCE_FAILURE = 'UPDATE_STRIPE_SOURCE_FAILURE';
export const BILLING_SETUP_COMPLETED = 'BILLING_SETUP_COMPLETED';
export const GET_UPCOMING_INVOICE_REQUESTED = 'GET_UPCOMING_INVOICE_REQUESTED';
export const GET_UPCOMING_INVOICE_SUCCESS = 'GET_UPCOMING_INVOICE_SUCCESS';
export const GET_UPCOMING_INVOICE_FAILURE = 'GET_UPCOMING_INVOICE_FAILURE';
export const GET_PAST_INVOICES_REQUESTED = 'GET_PAST_INVOICES_REQUESTED';
export const GET_PAST_INVOICES_SUCCESS = 'GET_PAST_INVOICES_SUCCESS';
export const GET_PAST_INVOICES_FAILURE = 'GET_PAST_INVOICES_FAILURE';

// Token-related actions
export const CREATE_TOKEN_REQUESTED = 'CREATE_TOKEN_REQUESTED';
export const CREATE_TOKEN_SUCCESS = 'CREATE_TOKEN_SUCCESS';
export const CREATE_TOKEN_FAILURE = 'CREATE_TOKEN_FAILURE';
export const GET_TOKENS_REQUESTED = 'GET_TOKENS_REQUESTED';
export const GET_TOKENS_FAILURE = 'GET_TOKENS_FAILURE';
export const GET_TOKENS_SUCCESS = 'GET_TOKENS_SUCCESS';
export const DELETE_TOKEN_REQUESTED = 'DELETE_TOKEN_REQUESTED';
export const DELETE_TOKEN_FAILURE = 'DELETE_TOKEN_FAILURE';
export const DELETE_TOKEN_SUCCESS = 'DELETE_TOKEN_SUCCESS';

// Instances-related actions
export const GET_INSTANCES_REQUESTED = 'GET_INSTANCES_REQUESTED';
export const GET_INSTANCES_POLL = 'GET_INSTANCES_POLL';
export const GET_INSTANCES_FAILURE = 'GET_INSTANCES_FAILURE';
export const GET_INSTANCES_SUCCESS = 'GET_INSTANCES_SUCCESS';

// Instance-related actions
export const GET_INSTANCE_REQUESTED = 'GET_INSTANCE_REQUESTED';
export const GET_INSTANCE_POLL = 'GET_INSTANCE_POLL';
export const GET_INSTANCE_FAILURE = 'GET_INSTANCE_FAILURE';
export const GET_INSTANCE_SUCCESS = 'GET_INSTANCE_SUCCESS';
export const GET_INSTANCE_WITH_PASSWORD_REQUESTED = 'GET_INSTANCE_WITH_PASSWORD_REQUESTED';
export const GET_INSTANCE_WITH_PASSWORD_SUCCESS = 'GET_INSTANCE_WITH_PASSWORD_SUCCESS';
export const GET_INSTANCE_WITH_PASSWORD_FAILURE = 'GET_INSTANCE_WITH_PASSWORD_FAILURE';
export const CHANGE_TAB_SELECTION = 'CHANGE_TAB_SELECTION';
export const ADD_INSTANCE_ACL_REQUESTED = 'ADD_INSTANCE_ACL_REQUESTED';
export const ADD_INSTANCE_ACL_FAILURE = 'ADD_INSTANCE_ACL_FAILURE';
export const ADD_INSTANCE_ACL_SUCCESS = 'ADD_INSTANCE_ACL_SUCCESS';
export const DELETE_INSTANCE_ACL_REQUESTED = 'DELETE_INSTANCE_ACL_REQUESTED';
export const DELETE_INSTANCE_ACL_FAILURE = 'DELETE_INSTANCE_ACL_FAILURE';
export const DELETE_INSTANCE_ACL_SUCCESS = 'DELETE_INSTANCE_ACL_SUCCESS';
export const DELETE_INSTANCE_REQUESTED = 'DELETE_INSTANCE_REQUESTED';
export const DELETE_INSTANCE_FAILURE = 'DELETE_INSTANCE_FAILURE';
export const DELETE_INSTANCE_SUCCESS = 'DELETE_INSTANCE_SUCCESS';
export const GET_INSTANCE_USERS_REQUESTED = 'GET_INSTANCE_USERS_REQUESTED';
export const GET_INSTANCE_USERS_FAILURE = 'GET_INSTANCE_USERS_FAILURE';
export const GET_INSTANCE_USERS_SUCCESS = 'GET_INSTANCE_USERS_SUCCESS';
export const DELETE_INSTANCE_USER_REQUESTED = 'DELETE_INSTANCE_USER_REQUESTED';
export const DELETE_INSTANCE_USER_FAILURE = 'DELETE_INSTANCE_USER_FAILURE';
export const DELETE_INSTANCE_USER_SUCCESS = 'DELETE_INSTANCE_USER_SUCCESS';
export const RESET_INSTANCE_ERROR_STATE = 'RESET_ERROR_STATE';
export const ADD_INSTANCE_USER_REQUESTED = 'ADD_INSTANCE_USER_REQUESTED';
export const ADD_INSTANCE_USER_FAILURE = 'ADD_INSTANCE_USER_FAILURE';
export const ADD_INSTANCE_USER_SUCCESS = 'ADD_INSTANCE_USER_SUCCESS';
export const GET_INSTANCE_DATABASES_REQUESTED = 'ADD_INSTANCE_DATABASES_REQUESTED';
export const GET_INSTANCE_DATABASES_FAILURE = 'ADD_INSTANCE_DATABASES_FAILURE';
export const GET_INSTANCE_DATABASES_SUCCESS = 'ADD_INSTANCE_DATABASES_SUCCESS';
export const ADD_INSTANCE_DATABASE_REQUESTED = 'ADD_INSTANCE_DATABASE_REQUESTED';
export const ADD_INSTANCE_DATABASE_FAILURE = 'ADD_INSTANCE_DATABASE_FAILURE';
export const ADD_INSTANCE_DATABASE_SUCCESS = 'ADD_INSTANCE_DATABASE_SUCCESS';
export const DELETE_INSTANCE_DATABASE_REQUESTED = 'DELETE_INSTANCE_DATABASE_REQUESTED';
export const DELETE_INSTANCE_DATABASE_FAILURE = 'DELETE_INSTANCE_DATABASE_FAILURE';
export const DELETE_INSTANCE_DATABASE_SUCCESS = 'DELETE_INSTANCE_DATABASE_SUCCESS';
export const GET_INSTANCE_CERTIFICATES_REQUESTED = 'GET_INSTANCE_CERTIFICATES_REQUESTED';
export const GET_INSTANCE_CERTIFICATES_FAILURE = 'GET_INSTANCE_CERTIFICATES_FAILURE';
export const GET_INSTANCE_CERTIFICATES_SUCCESS = 'GET_INSTANCE_CERTIFICATES_SUCCESS';
export const GET_INSTANCE_CLIENT_CERTIFICATES_REQUESTED =
  'GET_INSTANCE_CLIENT_CERTIFICATES_REQUESTED';
export const GET_INSTANCE_CLIENT_CERTIFICATES_FAILURE = 'GET_INSTANCE_CLIENT_CERTIFICATES_FAILURE';
export const GET_INSTANCE_CLIENT_CERTIFICATES_SUCCESS = 'GET_INSTANCE_CLIENT_CERTIFICATES_SUCCESS';
export const GET_INSTANCE_CERTIFICATE_DOWNLOAD_REQUESTED =
  'GET_INSTANCE_CERTIFICATE_DOWNLOAD_REQUESTED';
export const GET_INSTANCE_CERTIFICATE_DOWNLOAD_FAILURE =
  'GET_INSTANCE_CERTIFICATE_DOWNLOAD_FAILURE';
export const GET_INSTANCE_CERTIFICATE_DOWNLOAD_SUCCESS =
  'GET_INSTANCE_CERTIFICATE_DOWNLOAD_SUCCESS';
export const CREATE_INSTANCE_CERTIFICATE_REQUESTED = 'CREATE_INSTANCE_CERTIFICATE_REQUESTED';
export const CREATE_INSTANCE_CERTIFICATE_FAILURE = 'CREATE_INSTANCE_CERTIFICATE_FAILURE';
export const CREATE_INSTANCE_CERTIFICATE_SUCCESS = 'CREATE_INSTANCE_CERTIFICATE_SUCCESS';
export const CREATE_INSTANCE_CLIENT_CERTIFICATE_REQUESTED =
  'CREATE_INSTANCE_CLIENT_CERTIFICATE_REQUESTED';
export const CREATE_INSTANCE_CLIENT_CERTIFICATE_FAILURE =
  'CREATE_INSTANCE_CLIENT_CERTIFICATE_FAILURE';
export const CREATE_INSTANCE_CLIENT_CERTIFICATE_SUCCESS =
  'CREATE_INSTANCE_CLIENT_CERTIFICATE_SUCCESS';
export const DELETE_INSTANCE_CERTIFICATE_REQUESTED = 'CREATE_INSTANCE_CERTIFICATE_REQUESTED';
export const DELETE_INSTANCE_CERTIFICATE_FAILURE = 'CREATE_INSTANCE_CERTIFICATE_FAILURE';
export const DELETE_INSTANCE_CERTIFICATE_SUCCESS = 'CREATE_INSTANCE_CERTIFICATE_SUCCESS';
export const GET_BACKUPS_REQUESTED = 'GET_BACKUPS_REQUESTED';
export const GET_BACKUPS_FAILURE = 'GET_BACKUPS_FAILURE';
export const GET_BACKUPS_SUCCESS = 'GET_BACKUPS_SUCCESS';
export const GET_PITR_BACKUP_REQUESTED = 'GET_PITR_BACKUP_REQUESTED';
export const GET_PITR_BACKUP_FAILURE = 'GET_PITR_BACKUP_FAILURE';
export const GET_PITR_BACKUP_SUCCESS = 'GET_PITR_BACKUP_SUCCESS';
export const PATCH_CONFIG_REQUESTED = 'PATCH_CONFIG_REQUESTED';
export const PATCH_CONFIG_FAILURE = 'PATCH_CONFIG_FAILURE';
export const PATCH_CONFIG_SUCCESS = 'PATCH_CONFIG_SUCCESS';
export const CHANGE_NODE_QUANTITY_REQUESTED = 'CHANGE_NODE_QUANTITY_REQUESTED';
export const CHANGE_NODE_QUANTITY_FAILURE = 'CHANGE_NODE_QUANTITY_FAILURE';
export const CHANGE_NODE_QUANTITY_SUCCESS = 'CHANGE_NODE_QUANTITY_SUCCESS';

// Create Instance-related actions
export const NEXT_CREATE_STAGE = 'NEXT_CREATE_STAGE';
export const PREVIOUS_CREATE_STAGE = 'PREVIOUS_CREATE_STAGE';
export const RESET_STEPS = 'RESET_STEPS';
export const SELECT_SERVICE = 'SELECT_SERVICE';
export const SELECT_VERSION = 'SELECT_VERSION';
export const SELECT_REGION = 'SELECT_REGION';
export const ENTER_NAME = 'ENTER_NAME';
export const SELECT_FLAVOR = 'SELECT_FLAVOR';
export const SELECT_PLAN = 'SELECT_PLAN';
export const ENTER_CIDR = 'ENTER_CIDR';
export const ENTER_ACL_NAME = 'ENTER_ACL_NAME';
export const SELECT_ACL_KIND = 'SELECT_ACL_KIND';
export const ADD_ACL = 'ADD_ACL';
export const REMOVE_ACL = 'REMOVE_ACL';
export const ADD_IPS_LATER = 'ADD_IPS_LATER';
export const SELECT_SERVICE_SUBTYPE = 'SELECT_SERVICE_SUBTYPE';
export const SELECT_PROVIDER = 'SELECT_PROVIDER';
export const CREATEINSTANCE_REQUESTED = 'CREATEINSTANCE_REQUESTED';
export const CREATEINSTANCE_FAILURE = 'CREATEINSTANCE_FAILURE';
export const CREATEINSTANCE_SUCCESS = 'CREATEINSTANCE_SUCCESS';
export const RESET_CREATEINSTANCE_ERROR_STATE = 'RESET_ERROR_STATE';
export const GETIP_REQUESTED = 'GETIP_REQUESTED';
export const GETIP_SUCCESS = 'GETIP_SUCCESS';
export const GETIP_FAILURE = 'GETIP_FAILURE';
export const GETIP_CLEAR = 'GETIP_CLEAR';
export const GET_PRICE_REQUESTED = 'GET_PRICE_REQUESTED';
export const GET_PRICE_SUCCESS = 'GET_PRICE_SUCCESS';
export const GET_PRICE_FAILURE = 'GET_PRICE_FAILURE';
export const SELECT_ADDON = 'SELECT_ADDON';
export const DESELECT_ADDON = 'DESELECT_ADDON';

// Instances in ORv4
export const GET_INSTANCESV4_REQUESTED = 'GET_INSTANCESV4_REQUESTED';
export const GET_INSTANCESV4_FAILURE = 'GET_INSTANCESV4_FAILURE';
export const GET_INSTANCESV4_SUCCESS = 'GET_INSTANCESV4_SUCCESS';

// Catalog-related actions (in CreateInstance)
export const GET_SERVICES_REQUESTED = 'GET_SERVICES_REQUESTED';
export const GET_SERVICES_FAILURE = 'GET_SERVICES_FAILURE';
export const GET_SERVICES_SUCCESS = 'GET_SERVICES_SUCCESS';
export const GET_SERVICESUBTYPES_REQUESTED = 'GET_SERVICESUBTYPES_REQUESTED';
export const GET_SERVICESUBTYPES_FAILURE = 'GET_SERVICESUBTYPES_FAILURE';
export const GET_SERVICESUBTYPES_SUCCESS = 'GET_SERVICESUBTYPES_SUCCESS';
export const GET_PROVIDERS_REQUESTED = 'GET_PROVIDERS_REQUESTED';
export const GET_PROVIDERS_FAILURE = 'GET_PROVIDERS_FAILURE';
export const GET_PROVIDERS_SUCCESS = 'GET_PROVIDERS_SUCCESS';
export const GET_VERSIONS_REQUESTED = 'GET_VERSIONS_REQUESTED';
export const GET_VERSIONS_FAILURE = 'GET_VERSIONS_FAILURE';
export const GET_VERSIONS_SUCCESS = 'GET_VERSIONS_SUCCESS';
export const GET_REGIONS_REQUESTED = 'GET_REGIONS_REQUESTED';
export const GET_REGIONS_FAILURE = 'GET_REGIONS_FAILURE';
export const GET_REGIONS_SUCCESS = 'GET_REGIONS_SUCCESS';
export const GET_PLANS_REQUESTED = 'GET_PLANS_REQUESTED';
export const GET_PLANS_FAILURE = 'GET_PLANS_FAILURE';
export const GET_PLANS_SUCCESS = 'GET_PLANS_SUCCESS';
export const GET_FLAVORS_REQUESTED = 'GET_FLAVORS_REQUESTED';
export const GET_FLAVORS_FAILURE = 'GET_FLAVORS_FAILURE';
export const GET_FLAVORS_SUCCESS = 'GET_FLAVORS_SUCCESS';
export const GET_ADDONS_REQUESTED = 'GET_ADDONS_REQUESTED';
export const GET_ADDONS_FAILURE = 'GET_ADDONS_FAILURE';
export const GET_ADDONS_SUCCESS = 'GET_ADDONS_SUCCESS';
export const GET_CATALOG_CONFIG_REQUEST = 'GET_CATALOG_CONFIG_REQUEST';
export const GET_CATALOG_CONFIG_FAILURE = 'GET_CATALOG_CONFIG_FAILURE';
export const GET_CATALOG_CONFIG_SUCCESS = 'GET_CATALOG_CONFIG_SUCCESS';

// Notifications
export const ENQUEUE_SNACKBAR = 'ENQUEUE_SNACKBAR';
export const REMOVE_SNACKBAR = 'REMOVE_SNACKBAR';
export const ENQUEUE_BANNER = 'ENQUEUE_BANNER';
export const ACTIVATE_BANNER = 'ACTIVATE_BANNER';
export const REMOVE_BANNER = 'REMOVE_BANNER';
export const SET_FREE_CREDIT_AWARE = 'SET_FREE_CREDIT_AWARE';
export const CLEAR_BANNER_STATE = 'CLEAR_BANNER_STATE';

// Users Management
export const GET_USER_REQUESTED = 'GET_USER_REQUESTED';
export const GET_USER_SUCCESS = 'GET_USER_SUCCESS';
export const GET_USER_FAILURE = 'GET_USER_FAILURE';
export const GET_USER_POLL = 'GET_USER_POLL';
export const PATCH_USER_REQUESTED = 'PATCH_USER_REQUESTED';
export const PATCH_USER_SUCCESS = 'PATCH_USER_SUCCESS';
export const PATCH_USER_FAILURE = 'PATCH_USER_FAILURE';
export const DELETE_USER_REQUESTED = 'DELETE_USER_REQUESTED';
export const DELETE_USER_SUCCESS = 'DELETE_USER_SUCCESS';
export const DELETE_USER_FAILURE = 'DELETE_USER_FAILURE';
export const CREATE_USERINVITE_REQUESTED = 'CREATE_USERINVITE_REQUESTED';
export const CREATE_USERINVITE_SUCCESS = 'CREATE_USERINVITE_SUCCESS';
export const CREATE_USERINVITE_FAILURE = 'CREATE_USERINVITE_FAILURE';
export const GET_USERINVITE_REQUESTED = 'GET_USERINVITE_REQUESTED';
export const GET_USERINVITE_SUCCESS = 'GET_USERINVITE_SUCCESS';
export const GET_USERINVITE_FAILURE = 'GET_USERINVITE_FAILURE';
export const DELETE_USERINVITE_REQUESTED = 'DELETE_USERINVITE_REQUESTED';
export const DELETE_USERINVITE_SUCCESS = 'DELETE_USERINVITE_SUCCESS';
export const DELETE_USERINVITE_FAILURE = 'DELETE_USERINVITE_FAILURE';
export const VALIDATE_INVITE_TOKEN_REQUESTED = 'VALIDATE_INVITE_TOKEN_REQUESTED';
export const VALIDATE_INVITE_TOKEN_FAILURE = 'VALIDATE_INVITE_TOKEN_FAILURE';
export const VALIDATE_INVITE_TOKEN_SUCCESS = 'VALIDATE_INVITE_TOKEN_SUCCESS';
export const ACCEPT_INVITATION_REQUESTED = 'ACCEPT_INVITATION_REQUESTED';
export const ACCEPT_INVITATION_SUCCESS = 'ACCEPT_INVITATION_SUCCESS';
export const ACCEPT_INVITATION_FAILURE = 'ACCEPT_INVITATION_FAILURE';

// Stats
export const GET_SPACEUSAGE_REQUESTED = 'GET_SPACEUSAGE_REQUESTED';
export const GET_SPACEUSAGE_FAILURE = 'GET_SPACEUSAGE_FAILURE';
export const GET_SPACEUSAGE_SUCCESS = 'GET_SPACEUSAGE_SUCCESS';

// Tracking
export const TRACK_BUTTON_CLICK = 'TRACK_BUTTON_CLICK';

// Client certs
export const GET_CLIENT_CERTIFICATE_REQUESTED = 'GET_CLIENT_CERTIFICATE_REQUESTED';
export const GET_CLIENT_CERTIFICATE_FAILURE = 'GET_CLIENT_CERTIFICATE_FAILURE';
export const GET_CLIENT_CERTIFICATE_SUCCESS = 'GET_CLIENT_CERTIFICATE_SUCCESS';
